import { render, staticRenderFns } from "./text-image-modal.vue?vue&type=template&id=6c58be22&"
import script from "./text-image-modal.vue?vue&type=script&lang=js&"
export * from "./text-image-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports